module.exports = __webpack_public_path__ + "static/media/15.41a9d21e.jpg";